import { Divider } from "../divider/Divider";

import type { ReactNode } from "react";

export interface TextEditorStatusBarProps {
  children?: ReactNode;
}

export function TextEditorStatusBar({ children }: TextEditorStatusBarProps) {
  return (
    <div className="TextEditorStatusBar">
      <div className="TextEditorStatusBar__body">{children}</div>
      <Divider size="sm" />
    </div>
  );
}
